import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.object.from-entries.js";
import { toUrl } from "../utils.js";
/**
 * Parses the CDN/server's native URL format
 */
export const parse = imageUrl => {
  const url = toUrl(imageUrl);
  const [modifiers, ...id] = url.pathname.split("/").slice(1);
  const params = Object.fromEntries(modifiers.split(",").map(modifier => {
    const [key, value] = modifier.split("_");
    return [key, value];
  }));
  if (params.s) {
    const [width, height] = params.s.split("x");
    params.w || (params.w = width);
    params.h || (params.h = height);
  }
  return {
    base: id.join("/"),
    width: Number(params.w) || undefined,
    height: Number(params.h) || undefined,
    quality: Number(params.q) || undefined,
    format: params.f || "auto",
    params,
    cdn: "ipx"
  };
};
export const generate = _ref => {
  var _params$modifiers;
  let {
    base: id,
    width,
    height,
    format,
    params
  } = _ref;
  const modifiers = (_params$modifiers = params === null || params === void 0 ? void 0 : params.modifiers) !== null && _params$modifiers !== void 0 ? _params$modifiers : {};
  if (width && height) {
    modifiers.s = width + "x" + height;
  } else if (width) {
    modifiers.w = "" + width;
  } else if (height) {
    modifiers.h = "" + height;
  }
  if (format) {
    modifiers.f = format;
  }
  const base = params !== null && params !== void 0 && params.base.endsWith("/") ? params === null || params === void 0 ? void 0 : params.base : (params === null || params === void 0 ? void 0 : params.base) + "/";
  const modifiersString = Object.entries(modifiers).map(_ref2 => {
    let [key, value] = _ref2;
    return key + "_" + value;
  }).join(",");
  const stringId = id.toString();
  const image = stringId.startsWith("/") ? stringId.slice(1) : stringId;
  return "" + base + modifiersString + "/" + image;
};
export const transform = options => {
  var _options$cdnOptions$i, _options$cdnOptions, _options$cdnOptions$i2, _options$cdnOptions3;
  const url = String(options.url);
  const parsedUrl = toUrl(url);
  const defaultBase = parsedUrl.pathname.startsWith("/_ipx") && parsedUrl.hostname !== "n" ? parsedUrl.origin + "/_ipx" : "/_ipx";
  const base = (_options$cdnOptions$i = (_options$cdnOptions = options.cdnOptions) === null || _options$cdnOptions === void 0 ? void 0 : (_options$cdnOptions$i2 = _options$cdnOptions.ipx) === null || _options$cdnOptions$i2 === void 0 ? void 0 : _options$cdnOptions$i2.base) !== null && _options$cdnOptions$i !== void 0 ? _options$cdnOptions$i : defaultBase;
  const isIpxUrl = base && base !== "/" && url.startsWith(base);
  if (isIpxUrl) {
    var _options$cdnOptions2;
    const parsed = parse(url.replace(base, ""));
    return generate(Object.assign({}, parsed, options, {
      params: Object.assign({}, (_options$cdnOptions2 = options.cdnOptions) === null || _options$cdnOptions2 === void 0 ? void 0 : _options$cdnOptions2.ipx, {
        base
      })
    }));
  }
  return generate(Object.assign({}, options, {
    base: url,
    params: Object.assign({}, (_options$cdnOptions3 = options.cdnOptions) === null || _options$cdnOptions3 === void 0 ? void 0 : _options$cdnOptions3.ipx, {
      base
    })
  }));
};